import { matchPath, useLocation } from "react-router";

import { AppRegistry } from "Apps/AppRegistry";
import { useMemo } from "react";

export const useMatchedApp = () => {
    const pathname = useLocation().pathname;

    return useMemo(
        () =>
            Object.values(AppRegistry).find((app) =>
                matchPath(
                    {
                        path: app.path,
                        end: false
                    },
                    pathname
                )
            ),
        [pathname]
    );
};
